import { z } from 'zod/v4';

import type { InfinexMessageNamespace } from './base';
import { generateEventSchema } from './schemaBuilder';

export const AuthMethods = ['new-auth-token'] as const;
const namespace: InfinexMessageNamespace = 'authentication';

export const newAuthTokenSchema = generateEventSchema({
  namespace,
  method: 'new-auth-token',

  // Disallow any request
  requestData: z.never(),
  // Disallow any response
  responseData: z.never(),
  notificationData: z
    .object({
      challenge: z.string(),
      authToken: z.string(),
    })
    .strict(),
});

/* ─────────────────── Aggregated schema arrays ─────────────────── */
export const authenticationRequestParamSchemas = [] as const;

export const authenticationResponseParamSchemas = [] as const;

export const authenticationNotificationParamSchemas = [
  newAuthTokenSchema.notificationParamsSchema,
] as const;

export const authenticationRequestEventSchemas = [] as const;

export const authenticationResponseEventSchemas = [] as const;

export const authenticationNotificationEventSchemas = [
  newAuthTokenSchema.notificationSchema,
] as const;
